import { OpenAPI } from "src/_genApi/bco/core/OpenAPI";
import { ServerHandler } from "./ServerHandler";
import {UserDto, UserInfoDto, UsersService} from "../../_genApi/bco";

export class ServerBCO extends ServerHandler {

	constructor() {
		super();
		OpenAPI.BASE = this.getServerUrl();
	}

	getServerUrl() {
		return 'http://120.138.72.49:11008';
	}

	async getUserInfo(userId: number): Promise<UserInfoDto> {
		return UsersService.getUserInfo(userId);
	}

	async getMyInfo(): Promise<UserDto> {
		return UsersService.getMyInfo();
	}

	getUserInfos(ids: number[]) {
		return UsersService.getUserByIds(ids);
	}
}
